/**
 * 管理后台用户接口
 * 管理后台用户接口API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import AccountDailyRiskQueryForm from '../../account_mgt/model/AccountDailyRiskQueryForm';
import AccountFreezeStatusVo from '../../account_mgt/model/AccountFreezeStatusVo';
import AccountFreezeUpsertForm from '../../account_mgt/model/AccountFreezeUpsertForm';
import AccountQueryForm from '../../account_mgt/model/AccountQueryForm';
import PagingAccountVo from '../../account_mgt/model/PagingAccountVo';
import PagingRedeemTextbookVo from '../../account_mgt/model/PagingRedeemTextbookVo';
import UpdatedVo from '../../account_mgt/model/UpdatedVo';
  /**
   * AccountMgt service.
   * @module account_mgt/api/AccountMgtApi
   * @version 0.2.0
   */

  /**
   * Constructs a new AccountMgtApi. 
   * @alias module:account_mgt/api/AccountMgtApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;



    /**
     * 分页查询账号信息
     * @param {module:account_mgt/model/AccountQueryForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:account_mgt/model/PagingAccountVo}
     */
this.findPageAccount = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling findPageAccount";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = PagingAccountVo;
      return this.apiClient.callApi(
        '/api/account_mgt/list', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 分页查询每日风控账号
     * @param {module:account_mgt/model/AccountDailyRiskQueryForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:account_mgt/model/PagingAccountVo}
     */
this.findPageDailyRiskAccount = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling findPageDailyRiskAccount";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = PagingAccountVo;
      return this.apiClient.callApi(
        '/api/account_mgt/risk/daily/list', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 根据账号id查询教材发放记录
     * @param {Integer} accountId 账号id
     * @param {Integer} pageNum 页码
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:account_mgt/model/PagingRedeemTextbookVo}
     */
this.findPagingRedeemTextbookByAccountId = function(accountId, pageNum) {
      var postBody = null;

      // verify the required parameter 'accountId' is set
      if (accountId == undefined || accountId == null) {
        throw "Missing the required parameter 'accountId' when calling findPagingRedeemTextbookByAccountId";
      }

      // verify the required parameter 'pageNum' is set
      if (pageNum == undefined || pageNum == null) {
        throw "Missing the required parameter 'pageNum' when calling findPagingRedeemTextbookByAccountId";
      }


      var pathParams = {
        'accountId': accountId
      };
      var queryParams = {
        'pageNum': pageNum
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = PagingRedeemTextbookVo;
      return this.apiClient.callApi(
        '/api/account_mgt/{accountId}/redeem_textbook_list', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 设置账号冻结
     * @param {Integer} accountId 账号id
     * @param {module:account_mgt/model/AccountFreezeUpsertForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:account_mgt/model/UpdatedVo}
     */
this.freezeAccount = function(accountId, body) {
      var postBody = body;

      // verify the required parameter 'accountId' is set
      if (accountId == undefined || accountId == null) {
        throw "Missing the required parameter 'accountId' when calling freezeAccount";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling freezeAccount";
      }


      var pathParams = {
        'accountId': accountId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/account_mgt/{accountId}/freeze', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 查询账号冻结记录列表
     * @param {Integer} accountId 账号id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:account_mgt/model/AccountFreezeStatusVo>}
     */
this.getAccountFreezeList = function(accountId) {
      var postBody = null;

      // verify the required parameter 'accountId' is set
      if (accountId == undefined || accountId == null) {
        throw "Missing the required parameter 'accountId' when calling getAccountFreezeList";
      }


      var pathParams = {
        'accountId': accountId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = [AccountFreezeStatusVo];
      return this.apiClient.callApi(
        '/api/account_mgt/{accountId}/freeze', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 移除账号角色
     * @param {Integer} accountId 账号id
     * @param {Integer} roleId 角色id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:account_mgt/model/UpdatedVo}
     */
this.removeAccountRole = function(accountId, roleId) {
      var postBody = null;

      // verify the required parameter 'accountId' is set
      if (accountId == undefined || accountId == null) {
        throw "Missing the required parameter 'accountId' when calling removeAccountRole";
      }

      // verify the required parameter 'roleId' is set
      if (roleId == undefined || roleId == null) {
        throw "Missing the required parameter 'roleId' when calling removeAccountRole";
      }


      var pathParams = {
        'accountId': accountId
      };
      var queryParams = {
        'roleId': roleId
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/account_mgt/{accountId}/role', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 设置账号角色
     * @param {Integer} accountId 账号id
     * @param {Integer} roleId 角色id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:account_mgt/model/UpdatedVo}
     */
this.setAccountRole = function(accountId, roleId) {
      var postBody = null;

      // verify the required parameter 'accountId' is set
      if (accountId == undefined || accountId == null) {
        throw "Missing the required parameter 'accountId' when calling setAccountRole";
      }

      // verify the required parameter 'roleId' is set
      if (roleId == undefined || roleId == null) {
        throw "Missing the required parameter 'roleId' when calling setAccountRole";
      }


      var pathParams = {
        'accountId': accountId
      };
      var queryParams = {
        'roleId': roleId
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/account_mgt/{accountId}/role', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 解除账号冻结
     * @param {Integer} accountId 账号id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:account_mgt/model/UpdatedVo}
     */
this.unfreezeAccount = function(accountId) {
      var postBody = null;

      // verify the required parameter 'accountId' is set
      if (accountId == undefined || accountId == null) {
        throw "Missing the required parameter 'accountId' when calling unfreezeAccount";
      }


      var pathParams = {
        'accountId': accountId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/account_mgt/{accountId}/freeze', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }
  };

  export default exports;
